import React, { ReactElement } from 'react';

interface Props {
  className?: string;
  fill?: string;
  hideName?: boolean;
}

export default function Logo({
  className,
  fill = '#7B2CFF',
  hideName = false,
}: Props): ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      height="39"
      viewBox={hideName ? '0 0 45 39' : '0 0 128 39'}
      width={hideName ? '45' : '128'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.095 13.5004C42.5523 10.8035 39.7671 4.09376 38.2141 7.04212C36.3746 10.0565 32.9681 12.7083 28.8202 14.7664C28.557 12.8454 27.6369 10.2294 26.5646 8.82915C26.2179 8.37648 25.797 8.08718 26.2337 9.61168C26.7367 11.5359 27.0983 13.4944 27.3156 15.4715C24.405 16.7512 21.3682 17.7217 18.2551 18.3669C18.2232 16.0937 17.7689 13.8462 16.9153 11.7393C19.3805 9.64141 21.3425 7.01538 22.656 4.05573C22.656 4.05573 22.921 3.06129 23.3847 3.45906C25.5709 4.71871 29.2145 9.16063 29.2145 9.16063C29.2145 9.16063 29.9513 10.2336 30.2568 9.43525C30.3216 9.22673 30.3412 9.00676 30.3143 8.79004C30.2875 8.57333 30.2147 8.36484 30.1009 8.17851C27.8209 3.97859 22.7222 0.608263 22.7222 0.608263C22.7222 0.608263 22.0459 0.276781 21.6623 0.608263C19.0124 4.2546 12.4539 5.05019 12.4539 5.05019C12.4539 5.05019 11.1952 5.31538 12.1889 5.44797C13.1826 5.58057 17.2237 5.58055 20.6023 3.79055C14.3088 17.3815 2.9143 13.0058 2.9143 13.0058C2.9143 13.0058 2.91237 13.0436 2.91484 13.109C2.9474 13.9711 5.26777 14.9453 6.12511 15.0357C9.39703 15.4168 12.6984 14.6302 15.4477 12.8145C15.4658 12.8433 15.4856 12.8709 15.5072 12.8972C16.1854 13.6474 16.8955 16.766 16.867 18.6344C13.6765 19.2221 10.4251 19.4083 7.18851 19.1888C7.11497 18.5749 6.89089 17.2421 6.29292 16.7185C5.76293 16.2544 5.69669 16.9837 5.69669 16.9837C5.81106 17.6661 5.8532 18.3587 5.8224 19.05C4.19022 18.857 2.5846 18.4826 1.03527 17.9337C0.502709 17.7396 0.526141 18.4711 1.03481 18.7283C8.62629 22.5661 24.5634 21.6301 37.4804 12.3728C37.5639 12.3121 37.6602 12.2713 37.7619 12.2535C37.8635 12.2356 37.9679 12.2412 38.0671 12.2698C38.1663 12.2984 38.2577 12.3492 38.3343 12.4185C38.4109 12.4877 38.4707 12.5735 38.5092 12.6694C39.5165 15.1758 42.0025 23.3451 36.4838 32.8973C36.4016 33.038 36.3726 33.2035 36.4021 33.3638C37.0427 36.6464 45.5433 26.9691 43.095 13.5004Z"
        fill={fill}
      />
      <path
        d="M34.2136 23.4533C32.4249 30.6134 26.6285 35.4107 25.4574 36.4715C24.2864 37.5322 25.6677 39.2321 26.9926 38.2376C35.6948 31.0257 35.1411 22.3263 35.1411 22.3263C34.8761 20.7351 34.2136 23.4533 34.2136 23.4533Z"
        fill={fill}
      />
      <path
        d="M24.5072 27.4496C22.398 31.6359 18.2081 33.9393 17.2436 34.4382C16.2791 34.9371 16.9492 36.4498 18.2612 36.2226C24.4196 33.5312 25.3735 27.4034 25.3735 27.4034C25.4024 26.0617 24.5072 27.4496 24.5072 27.4496Z"
        fill={fill}
      />
      <path
        d="M18.8494 27.4253C19.9965 25.566 19.3321 26.2095 18.9308 26.4373C18.9308 26.4373 14.8285 28.8346 12.6752 29.1189C10.5219 29.4031 11.3207 30.9108 11.3207 30.9108C11.3207 30.9108 11.8492 31.8218 13.2298 31.4382C14.6103 31.0547 17.7024 29.2847 18.8494 27.4253Z"
        fill={fill}
      />
      <path
        d="M13.5666 23.6419C12.6114 23.8439 10.1348 23.7585 8.96731 23.6523C7.79979 23.546 7.69368 24.2896 7.69368 24.2896C7.69368 24.2896 7.58753 25.6824 8.82581 25.6704C12.262 25.6371 14.1681 24.0063 14.1681 24.0063C14.5572 23.4398 14.5218 23.4398 13.5666 23.6419Z"
        fill={fill}
      />
      {!hideName && (
        <>
          <path
            d="M108.312 28.4721V22.7835C108.383 21.4918 108.865 20.261 109.684 19.2849C111.509 17.2465 114.07 17.5309 114.44 17.5594V20.6597C113.876 20.5993 113.305 20.6706 112.771 20.8683C112.115 21.1111 111.376 21.897 111.376 22.883V28.4721H108.312Z"
            fill={fill}
          />

          <path
            clipRule="evenodd"
            d="M65.6396 28.9998C69.628 28.9998 72.8612 25.5504 72.8612 21.2953C72.8612 17.0402 69.628 13.5908 65.6396 13.5908C61.6512 13.5908 58.418 17.0402 58.418 21.2953C58.418 25.5504 61.6512 28.9998 65.6396 28.9998ZM65.6382 25.3736C67.7497 25.3736 69.4614 23.5474 69.4614 21.2947C69.4614 19.042 67.7497 17.2159 65.6382 17.2159C63.5267 17.2159 61.815 19.042 61.815 21.2947C61.815 23.5474 63.5267 25.3736 65.6382 25.3736Z"
            fill={fill}
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M85.5544 28.4721V22.0894C85.5544 19.5715 83.4969 17.5303 80.9589 17.5303C78.4208 17.5303 76.3633 19.5715 76.3633 22.0894V28.4721H79.5802V26.4398C79.5804 26.4398 79.5805 26.4399 79.5807 26.4399V22.0891C79.5807 21.3337 80.1979 20.7214 80.9594 20.7214C81.7208 20.7214 82.338 21.3337 82.338 22.0891V28.4719H82.3375V28.4721H85.5544Z"
            fill={fill}
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M103.062 28.701V19.8867C103.062 16.4096 100.22 13.5908 96.7154 13.5908C93.2105 13.5908 90.3691 16.4096 90.3691 19.8867V28.701H93.8711V19.2545C93.8711 18.0602 95.1447 17.0919 96.7159 17.0919C98.2871 17.0919 99.5608 18.0602 99.5608 19.2545V28.701H103.062Z"
            fill={fill}
            fillRule="evenodd"
          />
          <path
            d="M127.728 28.4129L125.072 23.9365C126.879 22.5654 127.999 20.4031 127.999 18.0422H124.371V18.5511C124.371 20.1103 123.02 21.3258 121.469 21.1613V13.1533H118.379V28.4129H121.469V25.5319L122.552 25.1847L124.375 28.4129H127.728Z"
            fill={fill}
          />
          <rect
            fill={fill}
            height="2.62605"
            width="5.68977"
            x="93.8691"
            y="21.4692"
          />
        </>
      )}
    </svg>
  );
}
